import moment from 'moment-timezone'

const startOfDayInVenue = (year, monthIndex, day, venueTimezone) =>
  moment.tz({ year, month: monthIndex, day }, venueTimezone).startOf('day')

/**
 * Ant Design DatePicker disabledDate — no calendar days before today in venue TZ.
 */
export const disabledExpiryDate = venueTimezone => current => {
  if (!current) return false
  const todayStart = moment.tz(venueTimezone).startOf('day')
  const dayStart = startOfDayInVenue(
    current.year(),
    current.month(),
    current.date(),
    venueTimezone
  )
  return dayStart.isBefore(todayStart, 'day')
}

/**
 * Ant Design DatePicker disabledTime — when the selected day is today in venue TZ,
 * disable hours/minutes before the current moment.
 */
export const disabledExpiryTime = venueTimezone => selected => {
  if (!selected) return {}
  const now = moment.tz(venueTimezone)
  const selDayStart = startOfDayInVenue(
    selected.year(),
    selected.month(),
    selected.date(),
    venueTimezone
  )
  if (!selDayStart.isSame(now, 'day')) return {}

  const currentHour = now.hour()
  const currentMinute = now.minute()
  return {
    disabledHours: () => {
      const hours = []
      for (let h = 0; h < currentHour; h++) hours.push(h)
      return hours
    },
    disabledMinutes: selectedHour => {
      if (selectedHour < currentHour) {
        return [...Array(60).keys()]
      }
      if (selectedHour > currentHour) return []
      const minutes = []
      for (let m = 0; m < currentMinute; m++) minutes.push(m)
      return minutes
    }
  }
}
